<template>
  <div class="bo-upload">
    <el-upload :multiple="isSingle !== true" :class="item.attrs.showMethod === 'image' ? 'avatar-uploader' : ''"
      :action="action + (!item.attrs.params ? '' : item.attrs.params)" :on-success="handleSuccess"
      :before-upload="beforeUpload" :on-preview="handlePreview" :on-remove="handleRemove" :on-exceed="handleExceed"
      :before-remove="beforeRemove" :file-list="files" :list-type="listType" :headers="headers">
      <template>
        <el-button :type="item.attrs.buttonType || 'primary'" plain :icon="item.attrs.buttonIcon || 'el-icon-plus'">
          {{ item.attrs.buttonText }}</el-button>
        <div slot="tip" class="el-upload__tip" v-if="item.attrs.slotTip">
          {{ item.attrs.slotTip }}
        </div>
      </template>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        dialogImageUrl: "",
        dialogVisible: false,
        files: [],
        isArray: false,
        headers: {}
      };
    },
    props: {
      rowIndex: {
        type: Number,
        default: -1
      },
      value: [String, Array], // v-model
      item: {
        type: Object
      },
      action: {
        type: String,
        default () {
          return "/bo/api/v1/file/upload";
        }
      }
    },
    computed: {
      isSingle() {
        return (
          this.item.attrs.showMethod === "image" ||
          this.item.attrs.showMethod === "file"
        );
      },
      listType() {
        if (this.item.attrs.listType) {
          return this.item.attrs.listType;
        } else if (
          this.item.attrs.showMethod === "image" ||
          this.item.attrs.showMethod === "images"
        ) {
          return "picture-card"; //return "picture";
        } else {
          return "text";
        }
      }
    },
    watch: {
      value(val) {
        this.value = val;
      }
    },
    created() {
      let that = this;
      this.headers = this.$store.getters.headers;
      that.isArray = Array.isArray(this.value);
      if (
        that.item &&
        (that.item.attrs.showMethod === "image" ||
          that.item.attrs.showMethod === "file") &&
        that.isArray === false &&
        that.value
      ) {
        that.files.push({
          name: that.value.split("/")[that.value.split("/").length - 1],
          size: null,
          id: null,
          suffix: null,
          url: that.value
        });
      } else if (
        that.item &&
        (that.item.attrs.showMethod === "images" ||
          that.item.attrs.showMethod === "files") &&
        that.isArray === false &&
        that.value
      ) {
        that.value.split(";").forEach(function (value, index) {
          that.files.push({
            name: value.split("/")[value.split("/").length - 1],
            size: null,
            id: null,
            suffix: null,
            url: value
          });
        });
      } else if (that.item && that.isArray === true) {
        that.files = that.value;
      }
    },
    methods: {
      handleRemove(file, fileList) {
        if (this.isSingle === true) {
          this.files = [];
        } else {
          this.files = fileList;
        }
        this.handleChangeData();
      },
      handlePreview(file) {},
      handleExceed(files, fileList) {
        if (this.item.attrs.limit) {
          this.$message.warning(
            `当前限制选择 ${this.item.attrs.limit} 个文件，本次选择了 ${
            files.length
          } 个文件，共选择了 ${files.length + fileList.length} 个文件`
          );
        }
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${file.name}？`);
      },
      handleSuccess(res, file) {
        if (!res) return;
        if (this.isSingle === true) {
          this.files = res.data;
        } else {
          this.files = [...this.files, ...res.data];
        }
        this.handleChangeData();
      },
      handleChangeData(){
        if(this.rowIndex!==-1){
           this.$emit("change-row", this.item, this.rowIndex, this.files);
        }else{    
           this.$emit("change", this.item, this.files);      
        }
      },
      beforeUpload(file) {
        return true;
      }
    }
  };
</script>